import CodeBlockLowlight from '@tiptap/extension-code-block-lowlight';
import Link from '@tiptap/extension-link';
import Placeholder from '@tiptap/extension-placeholder';
import Underline from '@tiptap/extension-underline';
import StarterKit from '@tiptap/starter-kit';
import { common, createLowlight } from 'lowlight';

import { CustomImage } from './extensions/CustomImage';

/**
 * @see https://tiptap.dev/docs/editor/extensions/overview
 */
export const EDITOR_EXTENSIONS = [
  StarterKit.configure({
    codeBlock: false,
    heading: { levels: [1, 2, 3] },
    dropcursor: { width: 2, color: 'white' },
  }),
  Link.configure({
    openOnClick: false,
    autolink: true,
    defaultProtocol: 'https',
  }),
  Placeholder.configure({
    placeholder: '나누고 싶은 생각을 적어주세요.\n투표를 추가할 수도 있어요.',
  }),
  CodeBlockLowlight.configure({
    lowlight: createLowlight(common),
    defaultLanguage: 'plaintext',
  }),
  CustomImage,
  Underline,
];
